import type { ApiClient } from "./client";
import type { BoardSprintsResponse } from "./types";

/**
 * Board-scoped sprint list. A shared board's sprints span multiple projects,
 * so each returned sprint carries its own `project_key`. board_name is resolved
 * from Jira at read time (source of truth) and may be null if Jira is down.
 */
export async function listBoardSprints(
  client: ApiClient,
  boardId: number | string,
): Promise<BoardSprintsResponse> {
  return client.get<BoardSprintsResponse>(
    `/boards/${encodeURIComponent(String(boardId))}/sprints`,
  );
}
